"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _qrCodeContext = require("./qrCodeContext");
Object.keys(_qrCodeContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _qrCodeContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _qrCodeContext[key];
    }
  });
});
